
document.addEventListener("DOMContentLoaded", () => {
  // Select all search forms
  const forms = document.querySelectorAll('.search.relative.search--speech')

  forms.forEach((form) => {
    // Select the input within the current form
    const inputElement = form.querySelector('.search__input')

    // Check if the form and input exist
    if (form && inputElement) {
      form.addEventListener('submit', (event) => {
        const searchTerm = inputElement.value.trim()
        inputElement.value = searchTerm
        if (searchTerm.length <= 0) return
        if (searchTerm.startsWith('"') && searchTerm.endsWith('"')) return
        inputElement.value = `"${searchTerm}"`
      })
    }
  })
})